import { FC, useCallback, useState } from 'react'
import { DialogTitleWithCloseButton, DraggablePaperGenerator } from '@carsys/ui'
import Dialog from '@mui/material/Dialog'
import Button from '@mui/material/Button'
import { useTranslation } from 'react-i18next'
import { DontKnowLoginDetailsDialogForMijnGrossier } from './MijnGrossierWholesalers/DontKnowLoginDetailsDialogForMijnGrossier'
import { IShopWholesaler } from '@cbgms/api'
import { isMijnGrossierOrMgNl, isVPOMAXBE } from 'utils/Ordersystems/utils'
import { DontKnowLoginDefault } from './Default/DontKnowLoginDefault'

const dragID = 'drag-DONT-KNOW-LOGIN-DETAILS-INfO'

export const DontKnowLoginDetailsDialog: FC<{ wholesaler: IShopWholesaler }> = ({ wholesaler }) => {
  const { t } = useTranslation()
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const onClose = useCallback(() => setIsOpen(false), [setIsOpen])
  const onOpen = useCallback(() => setIsOpen(true), [setIsOpen])

  return (
    <>
      <Button fullWidth variant='text' size='small' color='primary' onClick={onOpen}>
        {t('Auth.BtnFogotCredentials')}
      </Button>

      <Dialog
        open={isOpen}
        onClose={onClose}
        maxWidth='sm'
        scroll='paper'
        PaperComponent={DraggablePaperGenerator(dragID)}
        data-testid='dont-know-login-details-dialog'
      >
        <DialogTitleWithCloseButton onClose={onClose} draggableIDHandler={dragID}>
          {t('Auth.Onboarding.dont-know-login-details-info-title')}
        </DialogTitleWithCloseButton>

        <ForgotPasswordSelection wholesaler={wholesaler} onClose={onClose} />
      </Dialog>
    </>
  )
}

interface ForgotPasswordSelectionProps {
  onClose: () => void
  wholesaler: IShopWholesaler
}

function ForgotPasswordSelection({ wholesaler, onClose }: ForgotPasswordSelectionProps) {
  /*
    AX VPOM uses MG to login, so direct those users also to MG forgot password content
  */
  if (isMijnGrossierOrMgNl(wholesaler) || isVPOMAXBE(wholesaler)) {
    return <DontKnowLoginDetailsDialogForMijnGrossier onClose={onClose} wholesaler={wholesaler} />
  }

  return <DontKnowLoginDefault onClose={onClose} />
}
